export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'DE',
  'merchantReturnLink': 'https://www.timberland.de/de-de/kundendienst/ruckversand',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
